import { create } from "zustand";
import { OpenAPI } from "../services/RuteplanAPI";
import { heightRestrictionConfig } from "../services/OgcService/HeightRestrictionService";
import { trafficMessageConfig } from "../services/OgcService/TrafficMessageService";

export type EnvironmentName = "prod" | "atm" | "stm" | "local";

export interface IEnvironmentSetting {
    routeUrl: string;
    heightRestrictionUrl: string;
    trafficMessageUrl: string;
}


function setDefaultOpenAPI() {
    OpenAPI.BASE = process.env.REACT_APP_BASE_ADRESS_PROD as string
}


function environmentSettingFromName(environmentName: EnvironmentName): IEnvironmentSetting {
    switch (environmentName) {
        case "prod":
            return {
                routeUrl: process.env.REACT_APP_BASE_ADRESS_PROD as string,
                heightRestrictionUrl: process.env.REACT_APP_HEIGHTRESTRICTION_URL_PROD as string,
                trafficMessageUrl: process.env.REACT_APP_TRAFFIC_MESSAGE_URL_PROD as string
            }
        case "atm":
            return {
                routeUrl: process.env.REACT_APP_BASE_ADRESS_ATM as string,
                heightRestrictionUrl: process.env.REACT_APP_HEIGHTRESTRICTION_URL_ATM as string,
                trafficMessageUrl: process.env.REACT_APP_TRAFFIC_MESSAGE_URL_ATM as string
            }
        case "stm":
            return {
                routeUrl: process.env.REACT_APP_BASE_ADRESS_STM as string,
                heightRestrictionUrl: process.env.REACT_APP_HEIGHTRESTRICTION_URL_STM as string,
                trafficMessageUrl: process.env.REACT_APP_TRAFFIC_MESSAGE_URL_STM as string            
            }
        case "local":
            return {
                routeUrl: process.env.REACT_APP_BASE_ADRESS_LOCAL as string,
                heightRestrictionUrl: process.env.REACT_APP_HEIGHTRESTRICTION_URL_LOCAL as string,
                trafficMessageUrl: process.env.REACT_APP_TRAFFIC_MESSAGE_URL_LOCAL as string
            }
        default:
            return {
                routeUrl: process.env.REACT_APP_BASE_ADRESS_PROD as string,
                heightRestrictionUrl: process.env.REACT_APP_HEIGHTRESTRICTION_URL_PROD as string,
                trafficMessageUrl: process.env.REACT_APP_TRAFFIC_MESSAGE_URL_PROD as string
            }
    }
}

export interface IEnvironmentSettingActions {
    setEnvironment: (environmentName: EnvironmentName) => void;
}

export interface IEnvironmentSettingState {
    environmentName: EnvironmentName;
    environmentSetting: IEnvironmentSetting;
    actions: IEnvironmentSettingActions;
}

const useEnvironmentSettingStore = create<IEnvironmentSettingState>( (set) => ({
    environmentName: "prod",
    environmentSetting: environmentSettingFromName("prod"),
    actions: {
        setEnvironment: (environmentName: EnvironmentName) => {
            const environmentSetting = environmentSettingFromName(environmentName);
            set({ 
                environmentSetting: environmentSetting,
                environmentName: environmentName
            });

            OpenAPI.BASE = environmentSetting.routeUrl;
            heightRestrictionConfig.URL = environmentSetting.heightRestrictionUrl;
            trafficMessageConfig.URL = environmentSetting.trafficMessageUrl;
        }
    }    
}))

export const useEnvironmentSetting = () => useEnvironmentSettingStore( (state) => state.environmentSetting);
export const useEnvironmentName = () => useEnvironmentSettingStore( (state) => state.environmentName);
export const useEnvironmentSettingActions = () => useEnvironmentSettingStore( (state) => state.actions);

setDefaultOpenAPI();